export default {"src":"/_next/static/media/UVV.0615d384.svg","height":18,"width":18};